<template>
    <lb-drawer
        data-testid="transaction-matching-config-new__ai-setup-drawer"
        :value="dialog"
        @input="$emit('update:dialog', $event)"
        heading="AI Setup"
        width="700"
        :loading="loading"
    >
        <template v-slot:body>
            <div class="d-flex">
                <v-spacer></v-spacer>
                <v-btn
                    data-testid="transaction-matching-config-new__ai-reset-button"
                    color="primary"
                    @click="$emit('reset')"
                >
                    <span>Reset</span>
                </v-btn>
            </div>
            <div>
                <v-row>
                    <v-col class="pt-0">
                        <div class="body-2 font-weight-bold mt-4">Column Mapping</div>
                        <div class="mt-2">
                            <v-simple-table data-testid="transaction-matching-config-new__ai-mapping-table" class="border-on" dense>
                                <thead class="tableHeaderBg">
                                    <tr>
                                        <!-- filenames[0] and filenames[1] -->
                                        <th scope="d1cols" class="text-center tableHeaderBg">
                                            {{ filenames[0] }}
                                        </th>
                                        <th scope="dtypes" class="text-center white tableHeaderBg">Data Type</th>
                                        <th scope="d2cols" class="text-center tableHeaderBg">
                                            {{ filenames[1] }}
                                        </th>
                                        <th class="text-center white tableHeaderBg">Setup Values</th>
                                        <th class="white tableHeaderBg">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(v, k) in columns" :key="k" :id="'automation-test-'+k">
                                        <td class="text-center">{{ v.data1 }}</td>
                                        <td class="text-center">
                                            <v-chip label><span>{{ v.type }}</span></v-chip>
                                        </td>
                                        <td class="text-center">{{ v.data2 }}</td>
                                        <td class="text-center" v-if="localSetupObj && localSetupObj[v.name]" style="height: 50px;">
                                            <div v-if="v.type === 'string'" style="width: 150px;height:100px">
                                                <lb-number
                                                    hidedetails
                                                    label="Match %"
                                                    v-model="localSetupObj[v.name].matchpercentage"
                                                    max="100"
                                                ></lb-number>
                                            </div>
                                            <!-- Note: Original used checks for 'number' and 'date' separately but logic was similar except max value and checkbox -->
                                            <div v-else-if="v.type === 'number'" style="width: 150px">
                                                <lb-number
                                                    hidedetails
                                                    label="Match %"
                                                    v-model="localSetupObj[v.name].matchpercentage"
                                                    max="100" 
                                                ></lb-number>
                                                <!-- Original had max="500" for number? line 2314 says max="500". I will use 500. -->
                                                <v-checkbox
                                                    dense
                                                    hide-details
                                                    class="ma-0 pa-0 mr-2"
                                                    label="Negative value"
                                                    v-model="localSetupObj[v.name].oppositesignmatch"
                                                ></v-checkbox>
                                            </div>
                                            <div v-else-if="v.type === 'date'" style="width: 150px">
                                                <!-- Original had max="365" for date? line 2320 says max="365". -->
                                                <lb-number
                                                    hidedetails
                                                    label="Match %"
                                                    v-model="localSetupObj[v.name].matchpercentage"
                                                    max="365"
                                                ></lb-number>
                                            </div>
                                        </td>
                                        <td>
                                            <v-btn icon @click="$emit('delete', { name: v.name, index: k, type: v.type })" color="error">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </template>
        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn
                data-testid="transaction-matching-config-new__ai-run-button"
                color="primary"
                @click="$emit('run', localSetupObj)"
            >
                <span>Run AI</span>
            </v-btn>
            <v-btn
                data-testid="transaction-matching-config-new__ai-cancel-button"
                color="primary ml-2"
                @click="$emit('update:dialog', false)"
            >
                <span>Cancel</span>
            </v-btn>
        </template>
    </lb-drawer>
</template>

<script>
export default {
    name: 'AISetupDrawer',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        filenames: {
            type: Array,
            default: () => ['', '']
        },
        columns: {
            type: [Array, Object], // copycolumns
            default: () => []
        },
        setupObj: {
            type: Object, // setupaiObj
            default: () => ({})
        }
    },
    data() {
        return {
            // We need a local object if we want to mutate it, or just use the prop if we are following the legacy pattern.
            // The original code mutated `setupaiObj`.
            // As with other components, I'll alias the prop or rely on parent mutation via v-model if standard behavior is expected.
            // But here v-model="localSetupObj[v.name].matchpercentage" writes deep into the object.
            // I'll return the prop as data or computed to make template matching easier, assuming reuse of the object.
            // But strictly, mutating props is bad. 
            // In Vue 2, passing object allows mutation.
        };
    },
    computed: {
        localSetupObj() {
            return this.setupObj;
        }
    }
}
</script>